// extracted by mini-css-extract-plugin
export default {"link":"fE-z","disabled":"gE-z"};